import pages from "../pages";
import { RouteLinkProps } from "../types/global";
import {
  URL_ABOUT_PROJECT,
  URL_AUTH_LOGIN,
  URL_BANNER,
  URL_BANNER_CREATE,
  URL_BANNER_UPDATE,
  URL_CHAT,
  URL_COURSES,
  URL_COURSES_CREATE,
  URL_COURSES_LESSON,
  URL_COURSES_LESSON_CREATE,
  URL_COURSES_LESSON_RESOURCE_CREATE,
  URL_COURSES_LESSON_UPDATE,
  URL_COURSES_TEST_CREATE,
  URL_COURSES_TEST_QUESTION_CREATE,
  URL_COURSES_UPDATE,
  URL_FAQ,
  URL_FAQ_CREATE,
  URL_FAQ_UPDATE,
  URL_MAIN,
  URL_NEWS,
  URL_NEWS_CREATE,
  URL_NEWS_UPDATE,
  URL_NOTIFICATIONS,
  URL_NOTIFICATIONS_CREATE,
  URL_PROFILE,
  URL_PROFILE_OVERVIEW,
  URL_PROFILE_SECURITY,
  URL_QUESTIONS,
  URL_QUESTIONS_CATEGORY_CREATE,
  URL_QUESTIONS_CREATE,
  URL_QUESTIONS_UPDATE,
  URL_SOS,
  URL_SOS_DETAILS,
  URL_SOS_PLACE,
  URL_TEAM,
  URL_TEAM_MEMBER_CREATE,
  URL_TEAM_MEMBER_UPDATE,
  URL_USERS,
  URL_VICTIM,
  URL_VICTIM_DETAILS,
  URL_VICTIM_STATUS_CREATE,
  URL_VICTIM_TYPE_CREATE,
  URL_VIDEO_LESSONS_QUESTIONS,
  URL_VIDEO_LESSONS_QUESTIONS_CREATE,
  URL_VOTE_CATEGORY,
  URL_VOTE_CATEGORY_CREATE,
  URL_VOTE_CATEGORY_UPDATE,
  URL_VOTE_QUESTION_CREATE,
  URL_VOTE_REQUESTS,
  URL_VOTE_REQUEST_VIEW,
} from "./page_urls";

export const adminPages: RouteLinkProps[] = [
  {
    component: pages.admin.MainPage,
    path: URL_MAIN,
  },
  {
    component: pages.admin.NewsPage,
    path: URL_NEWS,
  },
  {
    component: pages.admin.NewsCreatePage,
    path: URL_NEWS_CREATE,
  },
  {
    component: pages.admin.NewsUpdatePage,
    path: URL_NEWS_UPDATE,
  },
  {
    component: pages.admin.QuestionCreatePage,
    path: URL_VIDEO_LESSONS_QUESTIONS_CREATE,
  },
  {
    component: pages.admin.SosViewPage,
    path: URL_SOS_DETAILS,
  },
  {
    component: pages.admin.QuestionsPage,
    path: URL_VIDEO_LESSONS_QUESTIONS,
  },
  {
    component: pages.admin.NotificationsPage,
    path: URL_NOTIFICATIONS,
  },
  {
    component: pages.admin.NotificationCreatePage,
    path: URL_NOTIFICATIONS_CREATE,
  },
  {
    component: pages.admin.FaqsPage,
    path: URL_FAQ,
  },
  {
    component: pages.admin.FaqCreatePage,
    path: URL_FAQ_CREATE,
  },
  {
    component: pages.admin.ProfilePage,
    path: URL_PROFILE,
  },
  {
    component: pages.admin.ProfileOverviewTab,
    path: URL_PROFILE_OVERVIEW,
  },
  {
    component: pages.admin.ProfileSecurityTab,
    path: URL_PROFILE_SECURITY,
  },
  {
    component: pages.admin.UsersPage,
    path: URL_USERS,
  },
  {
    component: pages.admin.SosPage,
    path: URL_SOS,
  },
  {
    component: pages.admin.BannersPage,
    path: URL_BANNER,
  },
  {
    component: pages.admin.BannerCreatePage,
    path: URL_BANNER_CREATE,
  },
  {
    component: pages.admin.BannerUpdatePage,
    path: URL_BANNER_UPDATE,
  },
  {
    component: pages.admin.FaqUpdatePage,
    path: URL_FAQ_UPDATE,
  },
  {
    component: pages.admin.ChatPage,
    path: URL_CHAT,
  },
  {
    component: pages.admin.SosPlacesPage,
    path: URL_SOS_PLACE,
  },
  {
    component: pages.admin.QuestionsPage,
    path: URL_QUESTIONS,
  },
  {
    component: pages.admin.QuestionCreatePage,
    path: URL_QUESTIONS_CREATE,
  },
  {
    component: pages.admin.QuestionUpdatePage,
    path: URL_QUESTIONS_UPDATE,
  },
  {
    component: pages.admin.CategoryCreatePage,
    path: URL_QUESTIONS_CATEGORY_CREATE,
  },
  {
    component: pages.admin.CoursesPage,
    path: URL_COURSES,
  },
  {
    component: pages.admin.CourseCreatePage,
    path: URL_COURSES_CREATE,
  },
  {
    component: pages.admin.CourseUpdatePage,
    path: URL_COURSES_UPDATE,
  },
  {
    component: pages.admin.TestCreatePage,
    path: URL_COURSES_TEST_CREATE,
  },
  {
    component: pages.admin.LessonPage,
    path: URL_COURSES_LESSON,
  },
  {
    component: pages.admin.LessonCreatePage,
    path: URL_COURSES_LESSON_CREATE,
  },
  {
    component: pages.admin.LessonUpdatePage,
    path: URL_COURSES_LESSON_UPDATE,
  },
  {
    component: pages.admin.ResourceCreatePage,
    path: URL_COURSES_LESSON_RESOURCE_CREATE,
  },
  {
    component: pages.admin.TestQuestionCreatePage,
    path: URL_COURSES_TEST_QUESTION_CREATE,
  },
  {
    component: pages.admin.VictimResponsePage,
    path: URL_VICTIM_DETAILS,
  },
  {
    component: pages.admin.VictimsPage,
    path: URL_VICTIM,
  },
  {
    component: pages.admin.VictimStatusCreatePage,
    path: URL_VICTIM_STATUS_CREATE,
  },
  {
    component: pages.admin.VictimTypeCreatePage,
    path: URL_VICTIM_TYPE_CREATE,
  },
  {
    component: pages.admin.AboutProjectPage,
    path: URL_ABOUT_PROJECT,
  },
  {
    component: pages.admin.TeamPage,
    path: URL_TEAM,
  },
  {
    component: pages.admin.TeamCreatePage,
    path: URL_TEAM_MEMBER_CREATE,
  },
  {
    component: pages.admin.TeamUpdatePage,
    path: URL_TEAM_MEMBER_UPDATE,
  },
  {
    component: pages.admin.VoteCategoriesPage,
    path: URL_VOTE_CATEGORY,
  },
  {
    component: pages.admin.VoteCategoryCreatePage,
    path: URL_VOTE_CATEGORY_CREATE,
  },
  {
    component: pages.admin.VoteCategoryUpdatePage,
    path: URL_VOTE_CATEGORY_UPDATE,
  },
  {
    component: pages.admin.VoteQuestionCreatePage,
    path: URL_VOTE_QUESTION_CREATE,
  },
  {
    component: pages.admin.VoteReqPage,
    path: URL_VOTE_REQUESTS,
  },
  {
    component: pages.admin.VoteReqViewPage,
    path: URL_VOTE_REQUEST_VIEW,
  },
];

export const authPages: RouteLinkProps[] = [
  {
    component: pages.auth.LoginPage,
    path: URL_AUTH_LOGIN,
  },
];
